import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.blindreview');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-blindreview',
template: templateSource || '',
    styles: [``],
})
export class PageBlindreviewComponent implements OnInit {
    public id: string = '';
    public loading: boolean = true;
    public savingScoreId: string = '';
    public item: any = null;
    public scoreDrafts: any = {};

    constructor(@Inject( Service) public service: Service) {
        this.id = WizRoute.segment.id;
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data, message } = await wiz.call("get", { id: this.id });
        if (code === 200) {
            this.item = data;
            this.seedScoreDrafts();
        } else {
            await this.service.modal.error(message || "블라인드 심사 정보를 불러오지 못했습니다.");
        }

        this.loading = false;
        await this.service.render();
    }

    public seedScoreDrafts() {
        this.scoreDrafts = {};
        for (const score of this.item?.qualitative_items || []) {
            this.scoreDrafts[score.id] = {
                reviewer_score: score.reviewer_score,
                reviewer_note: score.reviewer_note || ""
            };
        }
    }

    public async saveScore(score: any) {
        if (!score?.id || this.savingScoreId) return;
        if (!this.item?.permissions?.can_update_scores) {
            await this.service.modal.error("점수 입력 권한이 필요합니다.");
            return;
        }

        const draft = this.scoreDrafts[score.id] || {};
        this.savingScoreId = score.id;
        await this.service.render();

        const { code, message } = await wiz.call("update_reviewer_score", {
            id: this.id,
            score_item_id: score.id,
            reviewer_score: draft.reviewer_score ?? "",
            reviewer_note: draft.reviewer_note || ""
        });
        this.savingScoreId = "";

        if (code === 200) {
            await this.load();
            return;
        }

        await this.service.modal.error(message || "점수 입력 처리에 실패했습니다.");
        await this.service.render();
    }

    public badgeClass(status: string) {
        status = status || "";
        if (status === 'FAIL_CANDIDATE' || status === 'MISSING_EVIDENCE' || status === 'MISMATCH') return 'bg-rose-50 text-rose-700 border border-rose-200';
        if (status === 'NEEDS_REVIEW' || status === 'NEEDS_HUMAN_REVIEW' || status === 'MANUAL_REVIEW_REQUIRED' || status === 'REVIEWER_REQUIRED' || status === 'UNREADABLE' || status === 'PARTIAL_MATCH' || status === 'INSUFFICIENT_EVIDENCE') return 'bg-amber-50 text-amber-700 border border-amber-200';
        if (status === 'REVIEW_COMPLETED' || status === 'MATCHED' || status === 'PASS' || status === 'PASS_CANDIDATE') return 'bg-emerald-50 text-emerald-700 border border-emerald-200';
        if (status === 'PROCESSING' || status === 'QUEUED' || status === 'processing' || status === 'queued') return 'bg-sky-50 text-sky-700 border border-sky-200';
        if (status === 'COMPLETED' || status === 'completed') return 'bg-emerald-50 text-emerald-700 border border-emerald-200';
        if (status === 'FAILED' || status === 'failed') return 'bg-rose-50 text-rose-700 border border-rose-200';
        return 'bg-zinc-50 text-zinc-600 border border-zinc-200';
    }
}

export default PageBlindreviewComponent;